import type { ContactPersonDto } from '@dhl/mdp-api'
import type { ContactPerson } from '~/common/model/contact'
import { convertToEmailDto } from '~/common/model/emails/conversions/convertToEmailDto'

export const convertToContactPersonDto = ({ firstName, lastName, email, phone }: ContactPerson): ContactPersonDto => ({
  firstName,
  lastName,
  email: convertToEmailDto(email),
  phone,
})
